import React, { useState } from 'react';
import { Title, Text, Paper, Button, Group, Badge, Progress, Stack, Divider, Table, Tabs } from '@mantine/core';
import { ArrowLeft, Edit, Pause, Play, X, CheckCircle, XCircle, Clock, Users, MessageCircle, Calendar } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
export function CampaignDetailsPage() {
  const navigate = useNavigate();
  const {
    campaignId
  } = useParams();
  const [isPaused, setIsPaused] = useState(false);
  const campaign = {
    id: campaignId,
    name: 'Reunião Diretório Municipal',
    status: 'Em andamento',
    list: 'Diretório Municipal',
    message: 'Olá {nome}! Convocamos todos os membros do Diretório Municipal para reunião extraordinária no dia 25/05/2024 às 19h. Sua presença é fundamental!',
    startDate: '23/05/2024',
    startTime: '09:00',
    interval: 30,
    total: 150,
    sent: 87,
    success: 85,
    failed: 2,
    pending: 63,
    attachment: 'convite-reuniao.pdf'
  };
  const logs = [{
    id: 1,
    contact: 'João Silva',
    phone: '+55 11 97777-7777',
    status: 'Enviado',
    time: 'Hoje, 09:00'
  }, {
    id: 2,
    contact: 'Maria Oliveira',
    phone: '+55 11 96666-6666',
    status: 'Enviado',
    time: 'Hoje, 09:01'
  }, {
    id: 3,
    contact: 'Carlos Santos',
    phone: '+55 11 95555-5555',
    status: 'Falhou',
    time: 'Hoje, 09:02'
  }, {
    id: 4,
    contact: 'Ana Souza',
    phone: '+55 11 94444-4444',
    status: 'Enviado',
    time: 'Hoje, 09:03'
  }, {
    id: 5,
    contact: 'Roberto Ferreira',
    phone: '+55 11 93333-3333',
    status: 'Enviado',
    time: 'Hoje, 09:04'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Concluída':
        return 'green';
      case 'Em andamento':
        return 'yellow';
      case 'Agendada':
        return 'blue';
      case 'Pausada':
        return 'orange';
      case 'Cancelada':
        return 'red';
      default:
        return 'gray';
    }
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Enviado':
        return <CheckCircle size={16} style={{
          color: '#00A86B'
        }} data-id="element-154" />;
      case 'Falhou':
        return <XCircle size={16} style={{
          color: '#DC2626'
        }} data-id="element-155" />;
      case 'Pendente':
        return <Clock size={16} style={{
          color: '#9CA3AF'
        }} data-id="element-156" />;
      default:
        return null;
    }
  };
  return <div className="space-y-6" data-id="element-157">
      <Button leftSection={<ArrowLeft size={18} data-id="element-159" />} onClick={() => navigate('/campaigns')} radius="lg" styles={{
      root: {
        backgroundColor: 'transparent',
        border: '1px solid #9ca3af',
        color: '#4b5563',
        height: '40px',
        '&:hover': {
          backgroundColor: '#f3f4f6'
        }
      }
    }} data-id="element-158">
        Voltar para Campanhas
      </Button>
      <div className="flex justify-between items-center" data-id="element-160">
        <div data-id="element-161">
          <Group gap="md" data-id="element-162">
            <Title order={2} className="text-primary" data-id="element-163">
              {campaign.name}
            </Title>
            <Badge color={getStatusColor(campaign.status)} variant="light" size="lg" data-id="element-164">
              {campaign.status}
            </Badge>
          </Group>
          <Text c="dimmed" data-id="element-165">Lista: {campaign.list}</Text>
        </div>
        <Group data-id="element-166">
          {campaign.status === 'Em andamento' && <Button leftSection={isPaused ? <Play size={18} data-id="element-168" /> : <Pause size={18} data-id="element-169" />} radius="lg" onClick={() => setIsPaused(!isPaused)} styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #FFCC00',
            color: '#FFCC00',
            height: '48px',
            '&:hover': {
              backgroundColor: '#FFF9E6'
            }
          }
        }} data-id="element-167">
              {isPaused ? 'Retomar' : 'Pausar'}
            </Button>}
          {campaign.status === 'Agendada' && <>
              <Button leftSection={<Edit size={18} data-id="element-171" />} radius="lg" styles={{
            root: {
              backgroundColor: 'transparent',
              border: '1px solid #0047AB',
              color: '#0047AB',
              height: '48px',
              '&:hover': {
                backgroundColor: '#E3F2FD'
              }
            }
          }} data-id="element-170">
                Editar
              </Button>
              <Button leftSection={<X size={18} data-id="element-173" />} radius="lg" styles={{
            root: {
              backgroundColor: 'transparent',
              border: '1px solid #DC2626',
              color: '#DC2626',
              height: '48px',
              '&:hover': {
                backgroundColor: '#FEE2E2'
              }
            }
          }} data-id="element-172">
                Cancelar
              </Button>
            </>}
        </Group>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-174">
        <Paper radius="lg" p="md" withBorder data-id="element-175">
          <Group justify="space-between" mb="xs" data-id="element-176">
            <Text size="sm" c="dimmed" data-id="element-177">
              Total
            </Text>
            <Users size={20} style={{
            color: '#0047AB'
          }} data-id="element-178" />
          </Group>
          <Title order={2} data-id="element-179">{campaign.total}</Title>
          <Text size="xs" c="dimmed" mt="xs" data-id="element-180">
            Mensagens totais
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-181">
          <Group justify="space-between" mb="xs" data-id="element-182">
            <Text size="sm" c="dimmed" data-id="element-183">
              Enviadas
            </Text>
            <CheckCircle size={20} style={{
            color: '#00A86B'
          }} data-id="element-184" />
          </Group>
          <Title order={2} data-id="element-185">{campaign.success}</Title>
          <Text size="xs" c="green" mt="xs" data-id="element-186">
            {(campaign.success / campaign.total * 100).toFixed(1)}% do total
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-187">
          <Group justify="space-between" mb="xs" data-id="element-188">
            <Text size="sm" c="dimmed" data-id="element-189">
              Falhas
            </Text>
            <XCircle size={20} style={{
            color: '#DC2626'
          }} data-id="element-190" />
          </Group>
          <Title order={2} data-id="element-191">{campaign.failed}</Title>
          <Text size="xs" c="red" mt="xs" data-id="element-192">
            {(campaign.failed / campaign.total * 100).toFixed(1)}% do total
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-193">
          <Group justify="space-between" mb="xs" data-id="element-194">
            <Text size="sm" c="dimmed" data-id="element-195">
              Pendentes
            </Text>
            <Clock size={20} style={{
            color: '#9CA3AF'
          }} data-id="element-196" />
          </Group>
          <Title order={2} data-id="element-197">{campaign.pending}</Title>
          <Text size="xs" c="dimmed" mt="xs" data-id="element-198">
            Aguardando envio
          </Text>
        </Paper>
      </div>
      <Paper radius="lg" p="md" withBorder data-id="element-199">
        <Group justify="space-between" mb="md" data-id="element-200">
          <Text fw={500} data-id="element-201">Progresso de Envio</Text>
          <Text size="sm" c="dimmed" data-id="element-202">
            {campaign.sent} de {campaign.total} (
            {(campaign.sent / campaign.total * 100).toFixed(0)}%)
          </Text>
        </Group>
        <Progress value={campaign.sent / campaign.total * 100} color="blue" size="lg" radius="xl" data-id="element-203" />
      </Paper>
      <Tabs defaultValue="details" data-id="element-204">
        <Tabs.List data-id="element-205">
          <Tabs.Tab value="details" leftSection={<MessageCircle size={16} data-id="element-207" />} data-id="element-206">
            Detalhes
          </Tabs.Tab>
          <Tabs.Tab value="logs" leftSection={<Calendar size={16} data-id="element-209" />} data-id="element-208">
            Log de Envios
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="details" pt="md" data-id="element-210">
          <Paper radius="lg" p="md" withBorder data-id="element-211">
            <Stack gap="md" data-id="element-212">
              <div data-id="element-213">
                <Text size="sm" fw={500} c="dimmed" data-id="element-214">
                  Mensagem
                </Text>
                <div className="bg-gray-50 p-4 rounded-lg mt-2" data-id="element-215">
                  <Text size="sm" style={{
                  whiteSpace: 'pre-wrap'
                }} data-id="element-216">
                    {campaign.message}
                  </Text>
                </div>
              </div>
              {campaign.attachment && <div data-id="element-217">
                  <Text size="sm" fw={500} c="dimmed" data-id="element-218">
                    Anexo
                  </Text>
                  <Badge color="blue" variant="light" size="lg" mt="xs" data-id="element-219">
                    {campaign.attachment}
                  </Badge>
                </div>}
              <Divider data-id="element-220" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-221">
                <div data-id="element-222">
                  <Text size="sm" fw={500} c="dimmed" data-id="element-223">
                    Data de Início
                  </Text>
                  <Group gap="xs" mt="xs" data-id="element-224">
                    <Calendar size={16} data-id="element-225" />
                    <Text size="sm" data-id="element-226">
                      {campaign.startDate} às {campaign.startTime}
                    </Text>
                  </Group>
                </div>
                <div data-id="element-227">
                  <Text size="sm" fw={500} c="dimmed" data-id="element-228">
                    Intervalo entre Mensagens
                  </Text>
                  <Group gap="xs" mt="xs" data-id="element-229">
                    <Clock size={16} data-id="element-230" />
                    <Text size="sm" data-id="element-231">{campaign.interval} segundos</Text>
                  </Group>
                </div>
              </div>
            </Stack>
          </Paper>
        </Tabs.Panel>
        <Tabs.Panel value="logs" pt="md" data-id="element-232">
          <Paper radius="lg" p="md" withBorder data-id="element-233">
            <Table highlightOnHover data-id="element-234">
              <Table.Thead data-id="element-235">
                <Table.Tr data-id="element-236">
                  <Table.Th data-id="element-237">Contato</Table.Th>
                  <Table.Th data-id="element-238">Telefone</Table.Th>
                  <Table.Th data-id="element-239">Status</Table.Th>
                  <Table.Th data-id="element-240">Horário</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody data-id="element-241">
                {logs.map(log => <Table.Tr key={log.id} data-id="element-242">
                    <Table.Td data-id="element-243">
                      <Text fw={500} data-id="element-244">{log.contact}</Text>
                    </Table.Td>
                    <Table.Td data-id="element-245">
                      <Text size="sm" data-id="element-246">{log.phone}</Text>
                    </Table.Td>
                    <Table.Td data-id="element-247">
                      <Group gap="xs" data-id="element-248">
                        {getStatusIcon(log.status)}
                        <Badge color={log.status === 'Enviado' ? 'green' : log.status === 'Falhou' ? 'red' : 'gray'} variant="light" data-id="element-249">
                          {log.status}
                        </Badge>
                      </Group>
                    </Table.Td>
                    <Table.Td data-id="element-250">
                      <Text size="sm" c="dimmed" data-id="element-251">
                        {log.time}
                      </Text>
                    </Table.Td>
                  </Table.Tr>)}
              </Table.Tbody>
            </Table>
          </Paper>
        </Tabs.Panel>
      </Tabs>
    </div>;
}